/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
import {Injectable} from '@angular/core';
import {UserModelService} from '../common/user-model.service';
import {ReleaseAuthorization} from './release-authorization.model';
import {Service} from '../common/service.class';

@Injectable()
export class ReleaseAuthorizationService extends UserModelService<ReleaseAuthorization> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'releaseAuthorization', ReleaseAuthorization);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/release/release-authorization.service.ts